import { Star, Quote, Facebook, Youtube, PenLine } from "lucide-react";
import { FadeUp, Eyebrow } from "./Reveal";

const GOOGLE_URL = "https://www.google.com/search?q=One+God+Roofing+Limited+Company+Sunyani";
const FB_URL = "https://www.facebook.com/search/top?q=One%20God%20Roofing%20Limited%20Company";
const YT_URL = "https://www.youtube.com/results?search_query=ONE+GOD+ROOFING+LIMITED+COMPANY";

export const Reviews = () => (
    <section id="reviews" data-testid="reviews-ratings-section" className="py-24 sm:py-32 bg-[#13191E] border-y border-white/10">
        <div className="max-w-7xl mx-auto px-5 sm:px-8 grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">
            <FadeUp>
                <Eyebrow>Google verified</Eyebrow>
                <div className="flex items-end gap-6 mt-6">
                    <p data-testid="google-rating-score-4-4" className="font-display font-extrabold text-[6.5rem] sm:text-[8rem] leading-[0.85] text-amber-500">
                        4.4
                    </p>
                    <div className="pb-2">
                        <div className="flex gap-1 text-amber-500">
                            {[...Array(5)].map((_, i) => (
                                <Star key={i} size={18} fill={i < 4 ? "currentColor" : "none"} strokeWidth={1.5} className={i === 4 ? "opacity-40" : ""} />
                            ))}
                        </div>
                        <p className="mt-2 text-sm text-[#94A3B8]">7 reviews on Google</p>
                    </div>
                </div>

                <blockquote className="mt-10 border-l-2 border-amber-500 pl-6">
                    <Quote size={22} className="text-amber-500 mb-3" />
                    <p className="font-display font-semibold text-2xl sm:text-3xl leading-snug text-[#F8FAFC]">
                        "Quality materials for your building."
                    </p>
                    <footer className="mt-3 font-mono2 text-[10px] uppercase tracking-[0.25em] text-[#64748B]">
                        — Google review summary
                    </footer>
                </blockquote>
            </FadeUp>

            <FadeUp delay={0.15} className="flex flex-col gap-4">
                <a
                    href={GOOGLE_URL}
                    target="_blank"
                    rel="noopener noreferrer"
                    data-testid="google-review-link"
                    className="group border border-white/10 bg-[#0B0F12] hover:border-amber-500/50 p-6 flex items-center justify-between gap-4 transition-colors"
                >
                    <div>
                        <p className="font-display font-bold uppercase text-lg text-[#F8FAFC]">Rate and review on Google</p>
                        <p className="text-sm text-[#94A3B8] mt-1">Worked with us? Your review helps Sunyani roof well.</p>
                    </div>
                    <PenLine size={20} className="text-amber-500 shrink-0 transition-transform group-hover:-translate-y-0.5" />
                </a>

                <a
                    href={FB_URL}
                    target="_blank"
                    rel="noopener noreferrer"
                    data-testid="facebook-profile-link"
                    className="group border border-white/10 bg-[#0B0F12] hover:border-amber-500/50 p-6 flex items-center justify-between gap-4 transition-colors"
                >
                    <div>
                        <p className="font-display font-bold uppercase text-lg text-[#F8FAFC]">One God Roofing Limited Company</p>
                        <p className="text-sm text-[#94A3B8] mt-1">On Facebook · 20+ followers</p>
                    </div>
                    <Facebook size={20} className="text-amber-500 shrink-0" />
                </a>

                <a
                    href={YT_URL}
                    target="_blank"
                    rel="noopener noreferrer"
                    data-testid="youtube-channel-link"
                    className="group border border-white/10 bg-[#0B0F12] hover:border-amber-500/50 p-6 flex items-center justify-between gap-4 transition-colors"
                >
                    <div>
                        <p className="font-display font-bold uppercase text-lg text-[#F8FAFC]">ONE GOD ROOFING LIMITED COMPANY</p>
                        <p className="text-sm text-[#94A3B8] mt-1">On YouTube · watch our crews at work</p>
                    </div>
                    <Youtube size={20} className="text-amber-500 shrink-0" />
                </a>
            </FadeUp>
        </div>
    </section>
);

export default Reviews;
